import { useState } from 'react';
import { Select } from 'antd';
import type { SelectProps } from 'antd/lib/select';

import { getAppInfo } from '@arcsite/utils';

const { platform } = getAppInfo();

function WindowsWVLazyCloseSelect(props: SelectProps) {
  const [open, setOpen] = useState(props.open);

  const onDropdownVisibleChange = (o: boolean) => {
    setTimeout(
      () => {
        setOpen(o);
        props.onDropdownVisibleChange?.(o);
      },
      // open 不延迟，close延迟
      o ? 0 : 500
    );
  };

  if (platform === 'windows')
    return (
      <Select
        {...props}
        open={open}
        onDropdownVisibleChange={onDropdownVisibleChange}
      />
    );
  return <Select {...props} />;
}

WindowsWVLazyCloseSelect.Option = Select.Option;

export default WindowsWVLazyCloseSelect;
